// extracted by mini-css-extract-plugin
module.exports = {"main":"not-found_main__3u66S","notFound":"not-found_notFound__32BmR"};